module.exports = __webpack_public_path__ + "static/media/nuanshi.1ff83621.png";